module.exports = __webpack_public_path__ + "nc_static/media/loading.2e05568c.svg";